import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Switch,
  FormControlLabel,
  Typography,
  IconButton,
  Grid,
  Tooltip,
  Stack,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  List,
  ListItem,
  Paper,
} from "@mui/material";
import { TimeField, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { Breadcrumb } from "react-bootstrap";
import Loader from "../Common/Loader";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./DefineWorkLocation.css";
import { useEffect, useRef } from "react";
import { apiRequest } from "../../services/api";
import { encryptData } from "../Common/encryptionUtils";
import GoogleMapWithMarker from "./GoogleMapWithMarker";
import { AccessLog } from "../../Utils/AccessLog";

const ShiftCard = ({
  work,
  index,
  onChange,
  onDelete,
  onAPIDataDelete,
  errors,
  workLocations,
  setWorkLocations,
  handleChange,
}) => {
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [oldLat, setOldLat] = useState("");
  const [oldLng, setOldLng] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [openLocationDialog, setOpenLocationDialog] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const debounceTimer = useRef(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setShowDropdown(false);

    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    if (!value) {
      setSuggestions([]);
      return;
    }

    debounceTimer.current = setTimeout(() => {
      fetchSuggestions(value);
    }, 300);
  };

  const handleLoadMore = () => {
    if (nextPageToken) {
      fetchSuggestions(inputValue, nextPageToken, true);
    }
  };

  console.log("latlat--->", lat);

  const fetchSuggestions = async (query, pageToken = null, append = false) => {
    if (!query) return;
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = { Authorization: `Bearer ${authToken}` };

      const url = `web_api/admin/search-places?query=${encodeURIComponent(
        query
      )}${pageToken ? `&page_token=${pageToken}` : ""}`;

      const response = await apiRequest(url, "GET", null, headers);
      const results = response.data.results || [];
      const newToken = response.data.next_page_token;

      setSuggestions((prev) => (append ? [...prev, ...results] : results));
      setNextPageToken(newToken || null);
      setShowDropdown(true);
    } catch (err) {
      console.error("Error fetching places:", err);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (item) => {
    setSelectedPlace(item);
    console.log("itemData---->", item);
    const lat = item?.geometry?.location?.lat;
    const lng = item?.geometry?.location?.lng;
    const locationValue = `${lat}, ${lng}`;
    handleChange(selectedIndex, "location", locationValue);
    setLat(lat);
    setLng(lng);
    setInputValue(`${item.name}, ${item.formatted_address}`);
    setSuggestions([]);
    setShowDropdown(false);
  };

  const [selectedIndex, setSelectedIndex] = useState(null);
  console.log("latDidate--->", lat);
  const handleLocationClick = (index, work) => {
    console.log("workData--->", work);
    if (lat === "" && lng === "") {
      setLat(work?.latitude);
      setLng(work?.longitude);
      setOldLat(work?.latitude);
      setOldLng(work?.longitude);
    } else {
      setLat(lat);
      setLng(lng);
      setOldLat(lat);
      setOldLng(lng);
    }
    setSelectedPlace(null);
    setSelectedIndex(index);
    setInputValue("");
    setOpenLocationDialog(true);
  };

  console.log("lattitudeData---->", lat);

  const handleCloseMap = () => {
    setLat(oldLat);
    setLng(oldLng);
    if (oldLat && oldLng) {
      const locationValue = `${oldLat}, ${oldLng}`;
      handleChange(selectedIndex, "location", locationValue);
    }
    setOpenLocationDialog(false);
  };

  return (
    <Card
      elevation={10}
      sx={{
        borderRadius: 4,
        overflow: "hidden",
        mb: 4,
        marginLeft: "15px",
        border: "1px solid #ddd",
        boxShadow: "0 12px 30px rgba(0,0,0,0.1)",
        // transition: "transform 0.1s ease, box-shadow 0.1s ease",
        "&:hover": {
          //   transform: "scale(1.03)",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: work.location_color,
          color: "#fff",
          px: 3,
          py: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #ccc",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h6" fontWeight={600} sx={{ fontSize: "15px" }}>
            Work Location #{index + 1}
          </Typography>
          <Tooltip title="Work Location Color">
            <Box
              sx={{
                position: "relative",
                width: "100px",
                height: "24px",
                borderRadius: "4px",
                overflow: "hidden",
                border: "1px solid #ddd",
                backgroundColor: work.location_color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: 600,
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              <input
                type="color"
                value={work.location_color}
                onChange={(e) =>
                  onChange(index, "location_color", e.target.value)
                }
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  cursor: "pointer",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography variant="body2" sx={{ border: "none", p: "5px" }}>
                  {work.location_color}
                </Typography>

                <i className="fas fa-edit" style={{ fontSize: "12px" }}></i>
              </Box>
            </Box>
          </Tooltip>
        </Box>

        {index !== 0 && !work.fromApi ? (
          <IconButton
            color="inherit"
            onClick={() => onDelete(index)}
            sx={{ fontSize: "18px" }}
          >
            <i className="fas fa-trash-alt deleteShfitBtn"></i>
          </IconButton>
        ) : (
          <IconButton
            color="inherit"
            onClick={() =>
              onAPIDataDelete(index, work?.geofence_work_location_templates_id)
            }
            sx={{ fontSize: "18px" }}
          >
            <i className="fas fa-trash-alt deleteShfitBtn"></i>
          </IconButton>
        )}
      </Box>

      <CardContent
        sx={{ padding: "25px 25px 0px 25px" }}
        className="WorkShiftMainDiv"
      >
        <Grid container spacing={3}>
          {/* Shift Name First */}
          <Grid item xs={12} md={5}>
            <TextField
              label="Work Location Name"
              variant="outlined"
              fullWidth
              required
              value={work.location_name}
              error={errors?.location_name}
              helperText={
                errors?.location_name && "Work location name is required"
              }
              onChange={(e) => onChange(index, "location_name", e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <i className="fas fa-clipboard-list"></i>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                sx: {
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: "#4a90e2 !important",
                  "& .MuiInputLabel-asterisk": {
                    color: "red", // 🔴 only the asterisk is red
                  },
                },
              }}
              sx={{
                "& .MuiInputBase-root": {
                  height: "50px",
                },
              }}
              autoFocus
            />
          </Grid>

          <Grid item xs={12} md={5}>
            <Tooltip title="Click to Search Address">
              <TextField
                label="Location"
                value={work.location || ""}
                error={errors?.location}
                helperText={errors?.location}
                placeholder="Select location"
                onClick={() => handleLocationClick(index, work)}
                required
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        // onClick={handleLocationClick}
                        size="small"
                        sx={{ p: 0.5 }}
                      >
                        <i className="fas fa-map-marker-alt"></i>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: "1rem",
                    fontWeight: 600,
                    color: "#4a90e2 !important",
                    "& .MuiInputLabel-asterisk": {
                      color: "red !important", // Red asterisk
                    },
                  },
                }}
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "50px",
                  },
                  "& .MuiInputBase-input": {
                    padding: "10px 0px",
                    fontSize: "14px",
                  },
                }}
              />
            </Tooltip>
          </Grid>

          {/* Shift Enabled Switch */}
          <Grid item xs={6} md={1}>
            <Typography
              variant="body1"
              color="text.primary"
              className="bluetooth-label label-switch userFormlabel workShiftLabel"
            >
              Status
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={work.status}
                  disabled
                  sx={{
                    cursor: "not-allowed",
                    "& .MuiSwitch-thumb": {
                      cursor: "not-allowed",
                    },
                    "& .MuiSwitch-track": {
                      cursor: "not-allowed",
                    },
                  }}
                />
              }
              label=""
            />
          </Grid>
          {/* Shift Color */}
        </Grid>
      </CardContent>

      <Dialog
        open={openLocationDialog}
        // onClose={() => setOpenLocationDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Search Location</DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Search Address"
            fullWidth
            value={inputValue}
            onChange={handleInputChange}
            InputProps={{
              endAdornment: loading && <CircularProgress size={20} />,
            }}
            autoFocus
          />
          {showDropdown && suggestions.length > 0 && (
            <Paper sx={{ mt: 1, maxHeight: 500, overflowY: "auto" }}>
              <List>
                {suggestions.map((item, index) => (
                  <ListItem
                    button
                    key={index}
                    onClick={() => handleSelect(item)}
                  >
                    {item.name}, {item.formatted_address}
                  </ListItem>
                ))}
              </List>
              {nextPageToken && (
                <div className="loadMoreBtnDiv">
                  <Button
                    className="loadMoreBtn"
                    onClick={handleLoadMore}
                    fullWidth
                  >
                    Load More
                  </Button>
                </div>
              )}
            </Paper>
          )}

          {(selectedPlace || (lat && lng)) && (
            <div style={{ marginTop: "16px" }}>
              {/* <Typography variant="subtitle1" gutterBottom>
                Selected Location: {selectedPlace.name}
              </Typography> */}
              <GoogleMapWithMarker
                selectedPlace={selectedPlace}
                latitude={lat}
                longitude={lng}
                setLat={setLat}
                setLng={setLng}
                handleChange={handleChange}
                selectedIndex={selectedIndex}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseMap()}>Cancel</Button>
          {/* <Button
            variant="contained"
            onClick={() => {
              // setLat(selectedPlace.geometry.location.lat);
              // setLng(selectedPlace.geometry.location.lng);
              setOpenLocationDialog(false);
            }}
          >
            Submit
          </Button> */}
          <Button
            variant="contained"
            onClick={() => {
              // if (selectedPlace && selectedIndex !== null) {
              //   const lat = selectedPlace.geometry.location.lat;
              //   const lng = selectedPlace.geometry.location.lng;
              //   const locationValue = `${lat}, ${lng}`;

              //   handleChange(selectedIndex, "location", locationValue); // ✅ Use handleChange
              // } else if (lat && lng && selectedIndex !== null) {
              //   const locationValue = `${lat}, ${lng}`;
              //   handleChange(selectedIndex, "location", locationValue); // ✅ Use handleChange
              // }
              setOpenLocationDialog(false);
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

const DefineWorkLocation = () => {
  const authToken = localStorage.getItem("authToken");
  const selectedTopBarPremises = JSON.parse(
    localStorage.getItem("selectedTopBarPremises")
  );
  console.log("selectedTopBarPremises-->", selectedTopBarPremises);
  const [isNewShiftAdded, setIsNewShiftAdded] = useState(false);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );
  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      setSelectedPremise(selected);
      if (selected?.work_location_feature == "false") {
        navigate("/dashboard");
      } else {
        console.log("selected-->", selected);
        fetchShiftTemplates(selected?.value);
      }
    }
  };
  const defaultWorkLocation = {
    location_name: "",
    location: "",
    location_color: "#2d64bc",
    status: true,
    fromApi: false,
  };

  const [workLocations, setWorkLocations] = useState([defaultWorkLocation]);
  const shiftEndRef = useRef(null);

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [errorsList, setErrorsList] = useState([{}]);

  const handleChange = (index, field, value) => {
    const updatedShifts = [...workLocations];
    const updatedErrors = [...errorsList];
    const newErrors = { ...updatedErrors[index] };

    updatedShifts[index][field] = value;

    // Field-level validation
    if (field === "location_name" && !value) {
      newErrors.location_name = "Work location name is required";
    } else if (field === "location" && !value) {
      newErrors.location = "Location is required";
    } else {
      delete newErrors[field]; // Clear field-specific error if valid
    }

    updatedErrors[index] = newErrors;
    setWorkLocations(updatedShifts);
    setErrorsList(updatedErrors);
  };

  console.log("ErrorList---->", errorsList);

  const onChange = (index, field, value) => {
    const updatedShifts = [...workLocations];
    updatedShifts[index] = {
      ...updatedShifts[index], // ✅ keeps the existing data
      [field]: value,
    };
    setWorkLocations(updatedShifts);
  };

  const validateShift = (work) => {
    const errors = {};

    // Check if work name is provided
    if (!work.location_name?.trim())
      errors.location_name = "Work location name is required";

    if (!work.location?.trim()) errors.location = "Location is required";

    return errors;
  };

  const addWorkLocation = () => {
    if (!selectedTopBarPremises?.value) {
      toast.info(
        "No premises are available. Please create a premise before adding a work locations.",
        {
          position: "top-right",
          autoClose: 6000,
        }
      );
      return;
    }

    let hasErrors = false;
    const newErrorsList = workLocations.map((work) => {
      const errors = validateShift(work);
      if (Object.keys(errors).length > 0) {
        hasErrors = true;
      }
      return errors;
    });

    if (hasErrors) {
      setErrorsList(newErrorsList); // Show all validation errors
      console.log("errorsList--->", errorsList);
      return; // Block adding new work
    }

    // Add new work if all existing are valid
    setWorkLocations([
      ...workLocations,
      {
        location_name: "",
        location: "",
        location_color: "#2d64bc",
        status: true,
        fromApi: false,
      },
    ]);
    setErrorsList([...newErrorsList, {}]); // Add an empty error object for new work
    setIsNewShiftAdded(true);
  };

  const deleteShift = (index) => {
    const updatedShifts = workLocations.filter((_, i) => i !== index);
    const updatedErrors = errorsList.filter((_, i) => i !== index);
    setWorkLocations(updatedShifts);
    setErrorsList(updatedErrors);
  };

  const deleteWorkLocation = (index, geofence_work_location_templates_id) => {
    deleteShift(index);
    handleDeleteWorkLocationAPI(geofence_work_location_templates_id);
  };

  const [deleteParams, setDeleteParams] = useState({ index: null, id: null });

  const handleOpenDeleteConfirm = (index, id) => {
    setDeleteParams({ index, id });
    setConfirmDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    const { index, id } = deleteParams;
    handleDeleteWorkLocationAPI(id, index);
    setConfirmDialogOpen(false);
  };

  const formatToTimeOnly = (value) => {
    const date = new Date(value);
    return date.toTimeString().split(" ")[0]; // "HH:mm:ss"
  };

  const handleSubmit = () => {
    let hasErrors = false;
    const newErrorsList = workLocations.map((work) => {
      const errors = validateShift(work);
      if (Object.keys(errors).length > 0) {
        hasErrors = true;
      }
      return errors;
    });

    if (hasErrors) {
      setErrorsList(newErrorsList); // Show validation errors
      return; // Prevent submission
    }

    // Format start_time and end_time to HH:mm:ss before submission
    // const formattedShifts = workLocations.map((work) => ({
    //   ...work,
    //   start_time: formatToTimeOnly(work.start_time),
    //   end_time: formatToTimeOnly(work.end_time),
    // }));
    handleSubmitToAPI();

    // Continue with API call using formattedShifts
  };

  const handleReset = () => {
    setWorkLocations([defaultWorkLocation]); // Reset to one default work
    setErrorsList([{}]); // Clear any validation errors
  };

  useEffect(() => {
    fetchShiftTemplates(selectedTopBarPremises?.value);
    AccessLog("Define Work Locations");
  }, []);

  console.log("workLocations--->", workLocations);

  useEffect(() => {
    if (isNewShiftAdded && shiftEndRef.current) {
      shiftEndRef.current.scrollIntoView({ behavior: "smooth" });
      setIsNewShiftAdded(false); // ✅ reset flag after scrolling
    }
  }, [isNewShiftAdded]);

  const fetchShiftTemplates = async (premise_id) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const apiResponse = await apiRequest(
        `api/user/getWorkLocationsTemplateByPremiseId?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.user_geo_work_location_templates_details
      ) {
        if (
          apiResponse?.data?.data?.user_geo_work_location_templates_details
            ?.length > 0
        ) {
          const mappedWorkLocations =
            apiResponse?.data?.data?.user_geo_work_location_templates_details.map(
              (work) => ({
                ...work,
                location: `${work?.latitude},${work?.longitude}`,
                status: work.status === "enabled" ? true : false,
                fromApi: true,
              })
            );
          setWorkLocations(mappedWorkLocations);
          setErrorsList(mappedWorkLocations.map(() => ({})));
        } else {
          setWorkLocations([defaultWorkLocation]);
        }
      } else {
        setWorkLocations([defaultWorkLocation]);
        toast.error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error fetching work templates", error);
      toast.error("Failed to fetch work templates");
    } finally {
      setLoading(false);
    }
  };

  const prepareShiftPayload = (premiseId, workLocations) => {
    return {
      premise_id: encryptData(premiseId),
      arrayofWorklocation: workLocations.map((work) => {
        const [lat, lng] = work.location
          .split(",")
          .map((coord) => coord.trim());

        return {
          geofence_work_location_templates_id:
            work.geofence_work_location_templates_id
              ? encryptData(work.geofence_work_location_templates_id.toString())
              : encryptData(""),
          location_name: encryptData(work.location_name),
          location: encryptData(work.location),
          latitude: encryptData(lat),
          longitude: encryptData(lng),
          location_color: work.location_color, // No encryption if not needed
          status: encryptData(work.status ? "enabled" : "disabled"),
        };
      }),
    };
  };

  const handleSubmitToAPI = async () => {
    setLoading(true);
    const encryptedPayload = prepareShiftPayload(
      selectedTopBarPremises?.value?.toString(),
      workLocations
    );

    console.log("encryptedPayload--->", encryptedPayload);

    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      console.log("encryptedPayload-->", encryptedPayload);
      const apiResponse = await apiRequest(
        "/api/user/defineWorkLocation",
        "POST",
        encryptedPayload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        const handleFetchAndToast = async () => {
          // Step 1: Call fetchShiftTemplates and wait for it to finish
          await fetchShiftTemplates(selectedTopBarPremises?.value);

          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 4000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting workLocations:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteWorkLocationAPI = async (
    geofence_work_location_templates_id,
    index
  ) => {
    setLoading(true);
    const payload = {
      geofence_work_location_templates_id: encryptData(
        geofence_work_location_templates_id?.toString()
      ),
    };
    console.log(
      "geofence_work_location_templates_id-->",
      geofence_work_location_templates_id
    );
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const apiResponse = await apiRequest(
        "/api/user/deleteWorkLocationById",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        const handleFetchAndToast = async () => {
          // Step 1: Call fetchShiftTemplates and wait for it to finish
          await fetchShiftTemplates(selectedTopBarPremises?.value);

          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 5000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
        deleteShift(index);
      } else {
        toast.info(apiResponse.data.message, {
          position: "top-right",
          autoClose: 6000,
        });
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting workLocations:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="contentHeader d-flex align-items-center gap-3 pb-3">
            <div className="contentDiv">
              <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>Work Locations</Breadcrumb.Item>
                <Breadcrumb.Item active>Define Locations</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <Box
                maxWidth="1100px"
                mx="auto"
                className="workLocaionMainBox"
                sx={{ backgroundColor: "#fafafa", maxWidth: "auto" }}
              >
                <Stack
                  direction="row"
                  justifyContent="center"
                  mt={3}
                  className="addShiftDiv"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<i className="fas fa-plus addShiftBtnIcon"></i>}
                    onClick={addWorkLocation}
                    className="addShiftBtn"
                    sx={{
                      borderRadius: 1.5,
                      textTransform: "capitalize",
                      px: 4,
                      py: 1.5,
                      fontWeight: 600,
                      backgroundColor: "#2d64bc",
                      "&:hover": {
                        backgroundColor: "#2d64bc",
                      },
                    }}
                  >
                    Add Work Location
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className="addShiftBtn"
                    onClick={handleSubmit}
                    sx={{
                      borderRadius: 1.5,
                      textTransform: "capitalize",
                      px: 4,
                      py: 1.5,
                      fontWeight: 600,
                      marginLeft: "20px",
                      backgroundColor: "#2d64bc",
                      "&:hover": {
                        backgroundColor: "#2d64bc",
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Stack>
                <Box
                  sx={{
                    maxHeight: "calc(100vh - 220px)",
                    overflowY: "auto",
                    paddingRight: "8px",
                    marginLeft: "-15px",
                  }}
                >
                  {workLocations.map((work, index) => (
                    <ShiftCard
                      key={index}
                      index={index}
                      work={work}
                      onChange={handleChange}
                      onDelete={deleteShift}
                      onAPIDataDelete={handleOpenDeleteConfirm}
                      errors={errorsList[index] || {}}
                      workLocations={workLocations}
                      setWorkLocations={setWorkLocations}
                      handleChange={handleChange}
                    />
                  ))}
                  <div ref={shiftEndRef} />
                </Box>
              </Box>

              <Dialog
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
              >
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  Confirm Delete
                </DialogTitle>
                <DialogContent dividers>
                  <Typography variant="body2" color="textSecondary">
                    Are you sure want to delete the work location?
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setConfirmDialogOpen(false)}>
                    Cancel
                  </Button>
                  <Button variant="contained" onClick={handleConfirmDelete}>
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefineWorkLocation;
